import React, { useContext } from 'react'
import { SignUp } from 'syngenta-react-components'
import { loginInfo } from '../../services/authConfig'
import { GlobalContext, AuthContext } from '../../services/context'
import {
  getUserProfile,
  getUserProfileByCongitoUsername
} from '../../services/apiHelper'
import Logo from '../../assets/images/GrowMore360_Logo.svg'

import jwt from 'jsonwebtoken'

const SignUpView = () => {
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const { authDispatch } = useContext(AuthContext)
  const cognitoHandler = (response, pathOption) => {
    if (response?.user?.username) {
      // authDispatch({ type: 'LOGIN_USER', payload: response.user })
      dispatch({ type: 'GO_TO_LOGIN' })
      getUserProfile(response.user.username)
        .then(res => {
          authDispatch({ type: 'UPDATE_USER_PROFILE', payload: res })
        })
        .catch(error => {
          console.error(error)
        })
    } else if (response?.accessToken) {
      let decoded = jwt.decode(response.accessToken)
      getUserProfileByCongitoUsername(decoded.sub)
        .then(res => {
          authDispatch({ type: 'LOGIN_USER', payload: res })
          authDispatch({ type: 'UPDATE_USER_PROFILE', payload: res })
        })
        .catch(error => {
          console.error(error)
        })
    } else if (response?.error) {
      trackEvent('sign_up_failed', response)
      console.error('ERROR: ', response.error)
    }
    return response
  }

  return (
    <div className='df fxdrc jcc aic'>
      <SignUp
        containerClasses='bgc-white bd1-s-darkgray w375 pr25 pl25'
        {...loginInfo}
        logoPath={Logo}
        handler={response => cognitoHandler(response, 'sign-up')}
      />
    </div>
  )
}

export default SignUpView

